module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-03.4fb97420.jpg";